import { createFileRoute } from '@tanstack/react-router';
import { PaymentRoute } from '../-PaymentRoute';

/**
 * Secured post-checkout success. `payment_` avoids nesting under `/payment`
 * (that route is a leaf with ChangePlanOverlay, not a layout outlet).
 */
export const Route = createFileRoute('/_secured/payment_/success')({
  component: PaymentRoute,
});
